/**
 * 留言点/踩赞
 * @author Kody
 * @see http://api.umucdn.cn/project/232/interface/api/4313
 */

import Api from '../../path';
import { fetchData } from '@umu/umu-fetch';

interface IInput {
    message_id: string;
    is_del: number; // 1 踩 0 赞
}

export const postMessageLike = (param: IInput): Promise<IStatusResponse> => {
    return fetchData(Api.PROFILE_MESSAGE_LIKE, param);
};
